import { ExcelFileData } from './types';

export const readExcelFile = async (file: File, sheetIndex = 0): Promise<ExcelFileData> => {
  const XLSX = await import('xlsx');
  const arrayBuffer = await file.arrayBuffer();
  const workbook = XLSX.read(arrayBuffer, { type: 'array', cellDates: false });
  const sheetName = workbook.SheetNames[sheetIndex] || workbook.SheetNames[0];
  const sheet = workbook.Sheets[sheetName];
  const jsonData = XLSX.utils.sheet_to_json<any[]>(sheet, { header: 1, raw: true, dateNF: 'yyyy-mm-dd' });

  if (jsonData.length === 0) {
    return { headers: [], dataRows: [] };
  }

  const headers = jsonData[0] as any[];
  const dataRows = jsonData.slice(1).filter(row => row.some((cell: any) => cell !== undefined && cell !== ''));

  return { headers, dataRows };
};
